

















import { Vue, Component, Prop } from "vue-property-decorator";
import RubricaAziende from "../../components/RubricaAziende.vue";
import { bus } from "../../main";

@Component({
  components: {
    RubricaAziende
  }
})
export default class RubricaAziendeDialog extends Vue {
  @Prop() idAzienda!: any;
  @Prop() nomeAzienda!: any;

  private dialog: boolean;
  private contattiDataTableParams: any;

  constructor() {
    super();
    this.dialog = false;
    this.contattiDataTableParams = {
      headers: [
        {
          text: "Nome",
          value: "nominativo"
        },
        {
          text: "Mansione",
          value: "mansione"
        },
        {
          text: "Telefono",
          value: "telefonoUno"
        },
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Dettagli contatto",
          value: "detailsContatto"
        },
        {
          text: "Modifica",
          value: "editContatto"
        },
        {
          text: "Cancella",
          value: "deleteContatto"
        }
      ],
      records: [],
      detailsDialogParams: {
        title: "DETTAGLI CONTATTO",
        type: "contattoAzienda"
      }
    };
  }
}
